// extracted by mini-css-extract-plugin
export var legendIndicator = "_89-1";
export var legendRight = "_89-0";